var _path, _path2, _path3, _path4, _path5, _path6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVentilaciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6998 28.5005C33.0511 28.5005 38.1998 24.471 38.1998 19.5003C38.1998 14.5296 33.0511 10.5 26.6998 10.5C20.3486 10.5 15.1998 14.5296 15.1998 19.5003C15.1998 24.471 20.3486 28.5005 26.6998 28.5005Z",
    fill: "#F5FBFA",
    stroke: "#228C80",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20.9753V18.9753H8.36262H15.5001",
    stroke: "#228C80",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50003 21.2254C8.98729 21.2254 11.0001 23.1956 11.0001 25.6135V27.2254H2V25.6135C2 23.1881 4.02042 21.2254 6.50003 21.2254Z",
    fill: "white",
    stroke: "#228C80",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19V15",
    stroke: "#228C80",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.0997V27.9752",
    stroke: "#228C80",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8749 11.0997V27.9752",
    stroke: "#228C80",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 13.9747,
    width: 7,
    height: 2.20003,
    rx: 1.10002,
    fill: "#F9839A",
    stroke: "#228C80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVentilaciones);
export default __webpack_public_path__ + "static/media/Ic_ventilaciones.3e4d38f302c9e62176c54e63f25d5aa2.svg";
export { ForwardRef as ReactComponent };